var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mars-view',{staticClass:"wrapper",style:({
    height: _vm.defaultLineHeight
        ? '24px'
        : _vm.size + 'px',
})},[_c('mars-view',{staticClass:"triangle",class:[
        _vm.direction === 1
            ? ''
            : 'triangle-up',
        _vm.animation
            ? _vm.direction === 1
                ? 'triangle-transition'
                : 'triangle-up-transition'
            : '',
    ],style:({
        'border-color': _vm.color + ' transparent transparent',
        'border-width': '5px 4px 0',
        'top': '10px',
    })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }